const notes = {
  trumpet: [
    'F#3',
    'Gb3',
    'G3',
    'G#3',
    'Ab3',
    'A3',
    'A#3',
    'Bb3',
    'B3',
    'Cb4',
    'B#3',
    'C4',
    'C#4',
    'Db4',
    'D4',
    'D#4',
    'Eb4',
    'E4',
    'Fb4',
    'E#4',
    'F4',
    'F#4',
    'Gb4',
    'G4',
    'G#4',
    'Ab4',
    'A4',
    'A#4',
    'Bb4',
    'B4',
    'Cb5',
    'B#4',
    'C5',
    'C#5',
    'Db5',
    'D5',
    'D#5',
    'Eb5',
    'E5',
    'Fb5',
    'E#5',
    'F5',
    'F#5',
    'Gb5',
    'G5',
    'G#5',
    'Ab5',
    'A5',
    'A#5',
    'Bb5',
    'B5',
    'Cb6',
    'B#5',
    'C6',
  ],
  frenchHorn: [
    'F3',
    'F#3',
    'Gb3',
    'G3',
    'G#3',
    'Ab3',
    'A3',
    'A#3',
    'Bb3',
    'B3',
    'Cb4',
    'B#3',
    'C4',
    'C#4',
    'Db4',
    'D4',
    'D#4',
    'Eb4',
    'E4',
    'Fb4',
    'E#4',
    'F4',
    'F#4',
    'Gb4',
    'G4',
    'G#4',
    'Ab4',
    'A4',
    'A#4',
    'Bb4',
    'B4',
    'Cb5',
    'B#4',
    'C5',
    'C#5',
    'Db5',
    'D5',
    'D#5',
    'Eb5',
    'E5',
    'Fb5',
    'E#5',
    'F5',
    'F#5',
    'Gb5',
    'G5',
    'G#5',
    'Ab5',
    'A5',
    'A#5',
    'Bb5',
    'B5',
    'Cb6',
    'B#5',
    'C6',
  ],
  trombone: [
    'E2',
    'E#2',
    'Fb2',
    'F2',
    'F#2',
    'Gb2',
    'G2',
    'G#2',
    'Ab2',
    'A2',
    'A#2',
    'Bb2',
    'B2',
    'Cb3',
    'B#2',
    'C3',
    'C#3',
    'Db3',
    'D3',
    'D#3',
    'Eb3',
    'E3',
    'E#3',
    'Fb3',
    'F3',
    'F#3',
    'Gb3',
    'G3',
    'G#3',
    'Ab3',
    'A3',
    'A#3',
    'Bb3',
    'B3',
    'Cb4',
    'B#3',
    'C4',
    'C#4',
    'Db4',
    'D4',
    'D#4',
    'Eb4',
    'E4',
    'E#4',
    'Fb4',
    'F4',
    'F#4',
    'Gb4',
    'G4',
    'G#4',
    'Ab4',
    'A4',
    'A#4',
    'Bb4',
  ],
  euphonium: [
    'E2',
    'E#2',
    'Fb2',
    'F2',
    'F#2',
    'Gb2',
    'G2',
    'G#2',
    'Ab2',
    'A2',
    'A#2',
    'Bb2',
    'B2',
    'Cb3',
    'B#2',
    'C3',
    'C#3',
    'Db3',
    'D3',
    'D#3',
    'Eb3',
    'E3',
    'E#3',
    'Fb3',
    'F3',
    'F#3',
    'Gb3',
    'G3',
    'G#3',
    'Ab3',
    'A3',
    'A#3',
    'Bb3',
    'B3',
    'Cb4',
    'B#3',
    'C4',
    'C#4',
    'Db4',
    'D4',
    'D#4',
    'Eb4',
    'E4',
    'E#4',
    'Fb4',
    'F4',
    'F#4',
    'Gb4',
    'G4',
    'G#4',
    'Ab4',
    'A4',
    'A#4',
    'Bb4',
  ],
  tuba: [
    'E1',
    'E#1',
    'Fb1',
    'F1',
    'F#1',
    'Gb1',
    'G1',
    'G#1',
    'Ab1',
    'A1',
    'A#1',
    'Bb1',
    'B1',
    'Cb2',
    'B#1',
    'C2',
    'C#2',
    'Db2',
    'D2',
    'D#2',
    'Eb2',
    'E2',
    'E#2',
    'Fb2',
    'F2',
    'F#2',
    'Gb2',
    'G2',
    'G#2',
    'Ab2',
    'A2',
    'A#2',
    'Bb2',
    'B2',
    'Cb3',
    'B#2',
    'C3',
    'C#3',
    'Db3',
    'D3',
    'D#3',
    'Eb3',
    'E3',
    'E#3',
    'Fb3',
    'F3',
    'F#3',
    'Gb3',
    'G3',
    'G#3',
    'Ab3',
    'A3',
    'A#3',
    'Bb3',
  ],
};

export { notes };
